import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  checkoutLinkContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '& a': {
      color: '#000',
      fontSize: 14,
      minWidth: 230,
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
}));
